import * as shopActions from '../actions/Shop';

const initialState = {
  shops: [],
  list: [],
  shopEmails: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  detail: {
    shopId: 1,
    groupName: 'グループ１',
    shopName: '店舗１',
    zipCode: '819-0000',
    countryCode: 'JP',
    prefectures: '福岡県',
    city: '福岡市中央区',
    address: '今泉1-20-2',
    building: 'MENTビル4F',
    phone: '090-0000-0000',
    email: 'test@test.com',
    introduction: '中華のお店です。',
    businessHours: '9:00-18:00',
    holiday: '土日',
    nearestStation: '西鉄福岡天神駅',
    priceRange: '3000-4000円',
    access: '西鉄福岡天神駅から徒歩5分',
    webPage: 'https://www.test.com/',
    geohash: 'abcdefg',
    status: '利用中',
    inviteUserId: 1,
    stealthMode: '表示',
    qrCode: 'https://test.s3-ap-northeast-1.amazonaws.com/qr.png',
    images: [
      {
        image:
          'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/restaurant1.png',
        imageId: 1,
        viewOrder: 1,
        status: 'REPORTED'
      },
      {
        image:
          'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/restaurant2.png',
        imageId: 2,
        viewOrder: 2,
        status: 'REPORTED'
      }
    ],
    shopAnniversaries: [
      {
        anniversaryId: 1,
        shopAnniversaryId: 1,
        shopId: 1,
        anniversary: '2000-05-01',
        message: '開店記念'
      },
      {
        anniversaryId: 2,
        shopAnniversaryId: 2,
        shopId: 2,
        anniversary: '2010-05-01',
        message: '10周年記念'
      }
    ],
    tags: [
      {
        tagId: 1,
        tagName: 'タグ1',
        viewOrder: 1
      },
      {
        tagId: 2,
        tagName: 'タグ2',
        viewOrder: 2
      },
      {
        tagId: 3,
        tagName: 'タグ3',
        viewOrder: 3
      },
      {
        tagId: 4,
        tagName: 'タグ4',
        viewOrder: 4
      },
      {
        tagId: 5,
        tagName: 'タグ5',
        viewOrder: 5
      },
      {
        tagId: 6,
        tagName: 'タグ6',
        viewOrder: 6
      }
    ],
    createdAt: '2019-01-01 12:00:00',
    updatedAt: '2019-01-01 12:00:00'
  },
  accessibleShops: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 1,
      name: '店舗１'
    },
    {
      id: 2,
      name: '店舗２'
    },
    {
      id: 3,
      name: '店舗３'
    },
    {
      id: 4,
      name: '店舗４'
    }
  ],
  gochiUsers: [
    {
      userId: 1,
      AccountId: 'gochi Taro',
      displayName: 'ごち 太郎'
    },
    {
      userId: 2,
      AccountId: 'gochi Hanako',
      displayName: 'ごち 花子'
    }
  ],
  stealthModes: [
    {
      id: 'UNSTEALTH',
      name: '表示'
    },
    {
      id: 'STEALTH',
      name: '非表示'
    }
  ],
  gochiRestrictions: [
    {
      id: 'MENTION_ONLY',
      name: '指名ごちのみ'
    },
    {
      id: 'ANY',
      name: '制限なし'
    }
  ],
  statuses: [
    {
      id: 'AVAILABLE',
      name: '利用可能'
    },
    {
      id: 'SUSPENDED',
      name: '利用停止中'
    }
  ],
  shopStatuses: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'UNREGISTER',
      name: '未登録'
    },
    {
      id: 'PRE_AVAILABLE',
      name: '準備中'
    },
    {
      id: 'AVAILABLE',
      name: '利用可能'
    },
    {
      id: 'SUSPENDED',
      name: '利用停止中'
    },
    {
      id: 'CLOSED',
      name: '閉店'
    }
  ],
  shopShowStatuses: [
    {
      id: 'CUSTOM',
      name: '特定の法人のみで表示'
    },
    {
      id: 'ALL',
      name: '全ての法人で表示'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const shops = (state = initialState, action) => {
  switch (action.type) {
    case shopActions.GET_SHOPS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case shopActions.GET_SHOPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.DOWNLOAD_SHOP_SUCCESS:
      return Object.assign({}, state, action.payload);
    case shopActions.DOWNLOAD_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.GET_SHOP_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case shopActions.GET_SHOP_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.COUNT_SHOP_EMAIL_SUCCESS:
      return Object.assign({}, state, { shopEmails: action.payload });
    case shopActions.COUNT_SHOP_EMAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.GET_SHOP_MENU_VIEW_ORDER_SUCCESS:
      return Object.assign({}, state, { shops: action.payload.list });
    case shopActions.GET_SHOP_MENU_VIEW_ORDER_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.GET_INVOICE_HISTORY_SHOP_SUCCESS:
      return Object.assign({}, state, {
        listHistoryInvoice: action.payload
      });
    case shopActions.GET_INVOICE_HISTORY_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.GET_INVOICE_SHOP_SUCCESS:
      return Object.assign({}, state, {
        listInvoiceGochi: action.payload
      });
    case shopActions.GET_INVOICE_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case shopActions.GET_BATCH_SHOP_SUCCESS:
      return Object.assign({}, state, {
        listBatchShop: action.payload
      });
    case shopActions.GET_BATCH_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default shops;
